import { DependencyList } from 'react';

export async function handleQueryError(error: Error) {
  const { toast } = await import('sonner');
  toast.error(error.message);
}
export const generateUUID = () => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Fallback for browsers without crypto.randomUUID
  const buffer = new Uint8Array(16);
  crypto.getRandomValues(buffer);
  const fallbackUUID = [...buffer]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `${fallbackUUID.slice(0, 8)}-${fallbackUUID.slice(8, 12)}-4${fallbackUUID.slice(12, 15)}-${((buffer[8] & 0x3f) | 0x80).toString(16)}${fallbackUUID.slice(15, 18)}-${fallbackUUID.slice(18)}`;
};

export const buildUrlWithParams = (
  path: string,
  params: Record<string, string> = {}
) => {
  // 解析原始路径中的参数
  const [basePath, pathQuery] = path.split('?');
  const pathParams = new URLSearchParams(pathQuery);
  const currentParams = new URLSearchParams(params);
  // 创建新的URL参数对象
  const mergedParams = new URLSearchParams({
    ...Object.fromEntries(pathParams.entries()),
    ...Object.fromEntries(currentParams.entries()),
  });

  return `${basePath}?${mergedParams.toString()}`;
};

// 获取或创建设备ID
export const getOrCreateDeviceId = () => {
  const deviceId = localStorage.getItem('kaze-device-id');
  if (!deviceId) {
    const newDeviceId = generateUUID();
    localStorage.setItem('kaze-device-id', newDeviceId);
    return newDeviceId;
  } else {
    return deviceId;
  }
};

export function isPlainObject(value: unknown): boolean {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  if (Object.getPrototypeOf(value) === null) {
    return true;
  }

  let proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

export function depsAreSame(
  oldDeps: DependencyList,
  deps: DependencyList
): boolean {
  if (oldDeps === deps) return true;
  for (let i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }
  return true;
}

export function getFileBase64(file: File, size?: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(size ? file.slice(0, size) : file);
    reader.onload = (event) => {
      const result = event.target?.result as string;
      resolve(size ? result?.slice(0, size) : result || '');
    };
    reader.onerror = (event) => {
      reject(event.target?.error);
    };
  });
}
